import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { useTranslation } from "react-i18next";
import RubbishBinIcon from "src/assets/images/rubbish-bin.png";
import DragIcon from "src/assets/images/4-lines.png";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const DraggableTagRow = ({ tag, index, moveTag, onDelete }) => {
  const { t } = useTranslation("test-package", "common");
  const ref = useRef(null);

  const [{ isOver }, drop] = useDrop({
    accept: "tag",
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Move when hovering at least 20% into the target row to prevent excessive flickering
      const threshold = (hoverBoundingRect.bottom - hoverBoundingRect.top) * 0.2;

      if (dragIndex < hoverIndex && hoverClientY < threshold) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverBoundingRect.bottom - hoverBoundingRect.top - threshold) {
        return;
      }

      moveTag(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const [, drag] = useDrag({
    type: "tag",
    item: () => {
      return { id: tag.display_order, index };
    },
  });

  drag(drop(ref));

  return (
    <tr
      ref={ref}
      style={{
        opacity: isOver ? 0.4 : 1,
        backgroundColor: isOver ? "#e3f2fd" : "transparent",
        border: isOver ? "2px dashed #2196f3" : "none",
      }}
    >
      <td className="width-by-px-60 text-center">
        <span>{index + 1}</span>
      </td>
      <td className="width-by-px-80 text-center">
        <div
          className="width-by-px-24 height-by-px-24 rounded-circle mx-auto"
          style={{
            backgroundColor: tag.color,
          }}
        />
      </td>
      <td>
        <TooltipWrapper
          id={`tagname-${index + 1}`}
          tooltipText={tag?.name}
          checkOverflow={true}
          tooltipClassName="max-width-by-px-300"
          placement="top"
        >
          <p className="mb-0 overflow-hidden text-truncate">{tag.name || ""}</p>
        </TooltipWrapper>
      </td>
      <td className="width-by-px-80 text-center">
        <div className="d-flex justify-content-center align-items-center">
          <TooltipWrapper
            id={`delete-${index + 1}`}
            tooltipText={t("list.tag_modal.delete_tag")}
            tooltipClassName="max-width-by-px-300"
            placement="top"
          >
            <button className="btn btn-sm btn-link p-1 text-muted me-1" onClick={() => onDelete(tag?.display_order)} type="button">
              <img src={RubbishBinIcon} className="width-by-px-24 text-dark-filter" alt="Rubbish bin icon" />
            </button>
          </TooltipWrapper>
          <div className="btn btn-sm btn-link p-1 text-muted drag-icon">
            <img src={DragIcon} className="width-by-px-24 text-dark-filter" alt="Drag icon" />
          </div>
        </div>
      </td>
    </tr>
  );
};

export default DraggableTagRow;
